// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import entityRelationTypeEntity from './entities/entity-relation-type.json';
import entityRelationTypeMenu from '../pages/entity-relation-type/menu.json';
import entityRelationTypeFullForm from '../pages/entity-relation-type/forms/full.json';
import entityRelationTypeContextForm from '../pages/entity-relation-type/forms/context.json';
import entityRelationTypeMiniForm from '../pages/entity-relation-type/forms/mini.json';
import entityRelationTypeLookupForm from '../pages/entity-relation-type/forms/lookup.json';
import entityRelationTypeTableView from '../pages/entity-relation-type/views/table.json';
import entityRelationTypeDashboardView from '../pages/entity-relation-type/views/dashboard.json';

/** Тип запису «Тип зв’язку» зі сторінками пакета: меню, форми та подання з pages/entity-relation-type/. */
export const entityRelationTypeDefinition: IRecordTypeDefinition = {
  ...entityRelationTypeEntity,
  views: assembleViewSet({
      table: entityRelationTypeTableView,
      dashboard: entityRelationTypeDashboardView,
  }),
  form: entityRelationTypeFullForm,
  forms: { full: entityRelationTypeFullForm, context: entityRelationTypeContextForm, mini: entityRelationTypeMiniForm, lookup: entityRelationTypeLookupForm },
  menu: entityRelationTypeMenu,
} as IRecordTypeDefinition;
